import { post } from '../../../../../api';

export const postMailHasBeenValidated = async (id: string) => {
  await post(undefined, `/verifyemail/${id}`, { ignoreAuthentication: true });
};
